import { addLibs } from './base'
import * as defaults from './defaults'
import * as panwds from './panwds'
import * as OidcClient from 'oidc-client-ts'
import ReactDOMServer from 'react-dom/server' // required by ag-grid for dom size
import sparkyFramework from '../framework'

export default addLibs({
  ...defaults,
  ...panwds,
  ReactDOMServer,
  OidcClient,
  OidcClientTs: OidcClient,
  sparkyFramework,
})
